@if ((isMobileOpen$ | async) && ui.overlay()) {
  <div
    class="fixed inset-0 z-40 bg-gray-900/50"
    (click)="closeSidebar()"
    (keydown.enter)="closeSidebar()"
    (keydown.space)="closeSidebar(); $event.preventDefault()"
    role="button"
    tabindex="0"
    aria-label="Cerrar menú"
  ></div>
}
